/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_ACTLABEL =
  'GET_CURRENT_DISPLAY_OBJ_ACTLABEL';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_ACTLABEL =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_ACTLABEL';
export const GET_PLAN_TYPE_DATA_ACTLABEL = 'GET_PLAN_TYPE_DATA_ACTLABEL';
export const GET_REBATE_PROGRAM_ACTLABEL = 'GET_REBATE_PROGRAM_ACTLABEL';
export const GET_REBATE_PROGRAM_NAME_ACTLABEL =
  'GET_REBATE_PROGRAM_NAME_ACTLABEL';
export const GET_ERROR_MSG_ACTLABEL = 'GET_ERROR_MSG_ACTLABEL';
export const GET_CONTACTS_ACTLABEL = 'GET_CONTACTS_ACTLABEL';
export const GET_CONTACTS_DROPDOWN = 'GET_CONTACTS_DROPDOWN';
export const GET_CONTACTS_DROPDOWN_NAME = 'GET_CONTACTS_DROPDOWN_NAME';
export const SET_ACTIVE_LABELER_DATA = 'SET_ACTIVE_LABELER_DATA';
export const SET_SELECTED_INPUT_ACTLABEL = 'SET_SELECTED_INPUT_ACTLABEL';
export const SET_REFRESH_DATA_ACTLABEL = 'SET_REFRESH_DATA_ACTLABEL';
export const REFRESH_ACTIVE_LABELER_DISPLAY = 'REFRESH_ACTIVE_LABELER_DISPLAY';
export const SET_DISPLAY_OBJ_ACTLABEL = 'SET_DISPLAY_OBJ_ACTLABEL';
